export const mockRefreshResponse = {
  code: '1001',
};
